<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        size="small"
        class="filter-item"
        type="primary"
        icon="el-icon-plus"
        @click="showAddDialog"
      >
        新增黑名单
      </el-button>
      <el-input
        size="small"
        v-model="listQuery.keywords"
        placeholder="关键词搜索"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <!-- <el-select
        size="small"
        v-model="listQuery.type"
        placeholder="黑名单类型"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="邮箱" value="email" />
        <el-option label="手机号" value="phone" />
        <el-option label="IP" value="ip" />
        <el-option label="设备ID" value="device_id" />
      </el-select> -->
      <el-select
        size="small"
        v-model="listQuery.is_enabled"
        placeholder="状态"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="启用拦截" value="1" />
        <el-option label="取消拦截" value="0" />
      </el-select>
      <el-button
        size="small"
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="ID" width="80">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="类型" width="120">
        <template slot-scope="scope">
          <el-tag>
            {{ typeMap[scope.row.type] || scope.row.type }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="黑名单值" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.value }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="备注" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.remark || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_enabled === 1 ? 'success' : 'info'">
            {{ scope.row.is_enabled === 1 ? '启用拦截' : '取消拦截' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="240">
        <template slot-scope="scope">
          <div style="display: flex; flex-wrap: wrap; gap: 5px; justify-content: center;">
            <el-button
              type="primary"
              size="mini"
              @click="showEditDialog(scope.row)"
              style="flex: 0 0 auto;"
            >
              修改
            </el-button>
            <el-button
              type="danger"
              size="mini"
              @click="handleDelete(scope.row)"
              style="flex: 0 0 auto;"
            >
              删除
            </el-button>
            <el-button
              :type="scope.row.is_enabled === 1 ? 'info' : 'success'"
              size="mini"
              @click="toggleEnable(scope.row)"
              style="flex: 0 0 auto;"
            >
              {{ scope.row.is_enabled === 1 ? '取消拦截' : '启用拦截' }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      :title="isEdit ? '修改黑名单' : '新增黑名单'"
      :visible.sync="addDialogVisible"
      :destroy-on-close="true"
      append-to-body
      width="500px"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :rules="addRules"
        label-width="100px"
        label-position="top"
      >
        <el-form-item label="黑名单类型" prop="type">
          <el-select v-model="addForm.type" placeholder="请选择类型">
            <el-option label="邮箱" value="email" />
            <!-- <el-option label="手机号" value="phone" />
            <el-option label="IP" value="ip" />
            <el-option label="设备ID" value="device_id" /> -->
          </el-select>
        </el-form-item>
        <el-form-item label="黑名单值" prop="value">
          <el-input v-model="addForm.value" placeholder="请输入黑名单值" />
        </el-form-item>
        <el-form-item>
          <el-alert
            title="支持通配符，如 *@gmail.com 可拦截所有 @gmail.com 后缀的邮箱"
            type="info"
            show-icon
            :closable="false"
            style="margin-bottom: 10px"
          />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="addForm.remark" placeholder="请输入备注" />
        </el-form-item>
        <el-form-item label="状态" prop="is_enabled">
          <el-radio-group v-model="addForm.is_enabled">
            <el-radio :label="1">启用拦截</el-radio>
            <el-radio :label="0">取消拦截</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="handleDialogClose">取消</el-button>
          <el-button type="primary" :loading="btnLoading" @click="submitAdd">
            确认
          </el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      addDialogVisible: false,
      btnLoading: false,
      isEdit: false,
      addForm: {
        id: undefined,
        type: 'email',
        value: '',
        remark: '',
        is_enabled: 1,
      },
      addRules: {
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        value: [{ required: true, message: '请输入黑名单值', trigger: 'blur' }],
        is_enabled: [
          { required: true, message: '请选择是否启用', trigger: 'blur' },
        ],
      },
      listQuery: {
        page: 1,
        limit: 10,
        type: '',
        value: '',
        keywords: '',
        is_enabled: '',
      },
      typeMap: {
        email: '邮箱',
        phone: '手机号',
        ip: 'IP',
        device_id: '设备ID',
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    toggleEnable(row) {
      this.$confirm(
        `此操作将${
          row.is_enabled === 1 ? '禁用' : '启用'
        }该黑名单项, 是否继续?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(() => {
          const newStatus = row.is_enabled === 1 ? 0 : 1
          request({
            url: '/api/backend/userBlacklist/enable',
            method: 'post',
            data: { id: row.id, is_enabled: newStatus },
          }).then((res) => {
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: `${newStatus === 1 ? '启用' : '禁用'}成功`,
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/userBlacklist/list',
        method: 'get',
        params: this.listQuery,
      })
        .then((res) => {
          this.list = res.data.data
          this.total = res.data.total
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    showAddDialog() {
      this.isEdit = false
      this.addDialogVisible = true
      this.addForm = {
        id: undefined,
        type: 'email',
        value: '',
        remark: '',
        is_enabled: 1,
      }
    },
    showEditDialog(row) {
      this.isEdit = true
      this.addDialogVisible = true
      this.addForm = {
        id: row.id,
        type: row.type,
        value: row.value,
        remark: row.remark || '',
        is_enabled: row.is_enabled,
      }
    },
    handleDialogClose() {
      this.addDialogVisible = false
      this.isEdit = false
      this.$nextTick(() => {
        this.$refs.addForm && this.$refs.addForm.clearValidate()
      })
    },
    submitAdd() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/userBlacklist/store',
            method: 'post',
            data: this.addForm,
          })
            .then(() => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: this.isEdit ? '修改成功' : '添加成功',
                type: 'success',
                duration: 2000,
              })
              this.handleDialogClose()
              this.getList()
            })
            .catch(() => {
              this.btnLoading = false
            })
        }
      })
    },
    handleDelete(row) {
      this.$confirm('此操作将删除该黑名单项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/userBlacklist/del',
            method: 'post',
            data: { id: row.id },
          }).then((res) => {
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: '删除成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
  },
}
</script>

<style scoped>
/* ...existing code... */
</style>
